import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import Engineer from '../pinnacles/Engineer';
import Hudson from '../pinnacles/Hudson';
import Russell from '../pinnacles/Russell';
import President from '../pinnacles/President';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    textAlign: 'center',
  },
  buttonGroup: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  selected: {
    backgroundColor: `${theme.palette.secondary.main}!important`,
    color: '#fff!important'
  }
}));


const components = {
  engineer: Engineer,
  hudson: Hudson,
  russell: Russell,
  president: President
};

const AwardContent = (props) => {
  const Component = components[props.config.id];
  return <Component config={props.config} key={props.config.id} />;
}

export default (props) => {
  const [selected, setSelected] = React.useState(props.config.awards && props.config.awards.length > 0 ? props.config.awards[0].id : '');

  const classes = useStyles();
  return (
    <>
    <div className={classes.buttonContainer}>
      <ToggleButtonGroup exclusive color="secondary" className={classes.buttonGroup} value={selected} onChange={(event, value) => setSelected(value)}>
        {props.config.awards && props.config.awards.map((award, index) => (
          <ToggleButton key={award.id} value={award.id} classes={{selected: classes.selected}}>{award.name}</ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
    { props.config.awards && props.config.awards.map( (award, index) => (
      <div hidden={award.id !== selected} key={award.id}>
        { award.id === selected && (
          <AwardContent config={award} />
        )}
      </div>
    ))}
    </>
  );
};